(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pts-landing-core"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.PtsLanding) return;

    const inMemoryState = {};
    const eventName = 'pts:statechange';

    const slugify = (value) =>
      String(value || '')
        .trim()
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '');

    const readState = (groupId) => {
      if (!inMemoryState[groupId]) inMemoryState[groupId] = {};
      return inMemoryState[groupId];
    };

    const setState = (groupId, nextState = {}, sourceId = '') => {
      const mergedState = { ...readState(groupId), ...nextState };
      inMemoryState[groupId] = mergedState;

      document.dispatchEvent(
        new CustomEvent(eventName, {
          detail: {
            groupId,
            state: mergedState,
            sourceId,
          },
        })
      );

      return mergedState;
    };

    const subscribe = (groupId, callback) => {
      const handler = (event) => {
        if (event.detail.groupId !== groupId) return;
        callback(event.detail.state, event.detail.sourceId);
      };

      document.addEventListener(eventName, handler);
      callback(readState(groupId), 'init');

      return () => document.removeEventListener(eventName, handler);
    };

    const setNodeVisibility = (node, visible) => {
      if (!node) return;
      node.hidden = !visible;
      node.setAttribute('aria-hidden', visible ? 'false' : 'true');
      node.style.display = visible ? '' : 'none';
    };

    const dispatchCartEvents = (payload) => {
      document.dispatchEvent(
        new CustomEvent('pts:cart-updated', {
          detail: payload,
        })
      );

      document.dispatchEvent(
        new CustomEvent('cart:refresh', {
          bubbles: true,
          detail: payload,
        })
      );

      document.dispatchEvent(
        new CustomEvent('theme:cart:refresh', {
          bubbles: true,
          detail: payload,
        })
      );

      if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS?.cartUpdate) {
        Promise.resolve(
          window.publish(window.PUB_SUB_EVENTS.cartUpdate, {
            source: 'pts-landing',
            cartData: payload,
          })
        ).catch(() => {});
      }
    };

    const updateCartCount = async () => {
      try {
        const cart = await fetch(window.routes?.cart_url ? `${window.routes.cart_url}.js` : '/cart.js', {
          headers: {
            Accept: 'application/json',
          },
        }).then((response) => response.json());

        document
          .querySelectorAll(
            '#cart-icon-bubble .cart-count-bubble span, .cart-count-bubble span, [data-cart-count], .header__icon--cart-count'
          )
          .forEach((node) => {
            node.textContent = cart.item_count;
          });

        dispatchCartEvents(cart);

        return cart;
      } catch (error) {
        console.warn('Unable to refresh cart count.', error);
        return null;
      }
    };

    const addToCart = async (variantId, quantity = 1, triggerElement = null) => {
      if (!variantId) return { ok: false };

      const activeButton = triggerElement;
      const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

      if (activeButton) {
        activeButton.setAttribute('aria-disabled', 'true');
        activeButton.classList.add('is-loading');
      }

      const buttonLabel = activeButton ? activeButton.querySelector('[data-pts-button-label]') : null;
      const loadingLabel = activeButton ? activeButton.getAttribute('data-loading-label') : '';
      const previousLabel = buttonLabel ? buttonLabel.textContent : '';

      if (buttonLabel && loadingLabel) {
        buttonLabel.textContent = loadingLabel;
      }

      try {
        const requestBody = {
          items: [
            {
              id: Number(variantId),
              quantity,
            },
          ],
        };

        const response = await fetch(window.routes?.cart_add_url || '/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: JSON.stringify(requestBody),
        });

        const responseJson = await response.json().catch(() => ({}));
        if (!response.ok || responseJson.status) {
          console.error('Add to cart error:', responseJson.description || responseJson.message);
          return { ok: false, response: responseJson };
        }

        await updateCartCount();

        // Trigger cart refresh and open drawer - compatible with the theme's CartDrawer
        document.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true,
          detail: { open: true }
        }));

        return { ok: true, response: responseJson };
      } catch (error) {
        console.error('Personal Touch landing add to cart failed.', error);
        return { ok: false, error };
      } finally {
        if (buttonLabel) {
          buttonLabel.textContent = previousLabel;
        }
        if (activeButton) {
          activeButton.classList.remove('is-loading');
          activeButton.removeAttribute('aria-disabled');
        }
      }
    };

    document.addEventListener('click', (event) => {
      const button = event.target.closest('[data-pts-add-to-cart]');
      if (!button) return;

      event.preventDefault();
      const quantity = Number.parseInt(button.dataset.quantity || '1', 10);
      addToCart(button.dataset.variantId, Number.isNaN(quantity) ? 1 : quantity, button);
    });

    const initializedGroups = new Set();

    const getDefaultConcern = (groupId) =>
      document.querySelector(`.pts-concerns[data-group-id="${groupId}"] [data-default-active="true"]`)?.dataset.concernId ||
      document.querySelector(`.pts-concerns[data-group-id="${groupId}"] [data-concern-id]`)?.dataset.concernId ||
      document.querySelector(`.pts-routine[data-group-id="${groupId}"] [data-concern-id]`)?.dataset.concernId ||
      document.querySelector(`.pts-kit[data-group-id="${groupId}"] [data-concern-id]`)?.dataset.concernId ||
      '';

    const getDefaultStep = (groupId, concernId) =>
      document.querySelector(
        `.pts-routine[data-group-id="${groupId}"] [data-step-tab][data-concern-id="${concernId}"][data-default-active="true"]`
      )?.dataset.stepId ||
      document.querySelector(
        `.pts-routine[data-group-id="${groupId}"] [data-step-tab][data-concern-id="${concernId}"]`
      )?.dataset.stepId ||
      '';

    const syncGroupUi = (groupId, state = readState(groupId)) => {
      let concernId = state.concernId || getDefaultConcern(groupId);
      let stepId = state.stepId;

      const concernTabs = Array.from(
        document.querySelectorAll(`.pts-concerns[data-group-id="${groupId}"] [data-concern-id]`)
      );
      const concernPanels = Array.from(
        document.querySelectorAll(`.pts-routine[data-group-id="${groupId}"] [data-concern-panel]`)
      );
      const stepTabs = Array.from(
        document.querySelectorAll(`.pts-routine[data-group-id="${groupId}"] [data-step-tab]`)
      );
      const stepPanels = Array.from(
        document.querySelectorAll(`.pts-routine[data-group-id="${groupId}"] [data-step-panel]`)
      );
      const kitPanels = Array.from(
        document.querySelectorAll(`.pts-kit[data-group-id="${groupId}"] [data-kit-panel]`)
      );
      const stickyCards = Array.from(
        document.querySelectorAll(`.pts-kit[data-group-id="${groupId}"] [data-sticky-card]`)
      );

      const knownConcernIds = [
        ...new Set(
          [...concernTabs, ...concernPanels, ...stepTabs, ...stepPanels, ...kitPanels, ...stickyCards]
            .map((node) => node.dataset.concernId)
            .filter(Boolean)
        ),
      ];

      if (!knownConcernIds.includes(concernId)) {
        concernId = knownConcernIds[0] || '';
      }

      const availableStepIds = stepTabs
        .filter((tab) => tab.dataset.concernId === concernId)
        .map((tab) => tab.dataset.stepId);

      if (!availableStepIds.includes(stepId)) {
        stepId = getDefaultStep(groupId, concernId);
      }

      concernTabs.forEach((tab) => {
        const isActive = tab.dataset.concernId === concernId;
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      concernPanels.forEach((panel) => {
        setNodeVisibility(panel, panel.dataset.concernId === concernId);
      });

      stepTabs.forEach((tab) => {
        const visible = tab.dataset.concernId === concernId;
        const isActive = visible && tab.dataset.stepId === stepId;
        setNodeVisibility(tab, visible);
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      stepPanels.forEach((panel) => {
        setNodeVisibility(panel, panel.dataset.concernId === concernId && panel.dataset.stepId === stepId);
      });

      kitPanels.forEach((panel) => {
        setNodeVisibility(panel, panel.dataset.concernId === concernId);
      });

      stickyCards.forEach((card) => {
        const isActive = card.dataset.concernId === concernId;
        setNodeVisibility(card, isActive);
        card.classList.toggle('is-ready', isActive);
      });

      if (concernId !== state.concernId || stepId !== state.stepId) {
        inMemoryState[groupId] = { ...state, concernId, stepId };
      }
    };

    const bindGroup = (groupId) => {
      if (!groupId || initializedGroups.has(groupId)) return;
      initializedGroups.add(groupId);

      const concernId = getDefaultConcern(groupId);
      const stepId = getDefaultStep(groupId, concernId);
      inMemoryState[groupId] = {
        concernId,
        stepId,
      };

      subscribe(groupId, (state) => syncGroupUi(groupId, state));
    };

    const initializeGroups = () => {
      document.querySelectorAll('[data-group-id]').forEach((element) => {
        bindGroup(element.dataset.groupId);
      });
    };

    document.addEventListener('click', (event) => {
      const concernTab = event.target.closest('.pts-concerns [data-concern-id]');
      if (concernTab) {
        const groupId = concernTab.closest('[data-group-id]')?.dataset.groupId;
        if (groupId) {
          setState(groupId, { concernId: concernTab.dataset.concernId, stepId: '' }, 'pts-global-concern');
        }
        return;
      }

      const stepTab = event.target.closest('.pts-routine [data-step-tab]');
      if (!stepTab) return;

      const groupId = stepTab.closest('[data-group-id]')?.dataset.groupId;
      if (!groupId) return;

      setState(
        groupId,
        { concernId: stepTab.dataset.concernId, stepId: stepTab.dataset.stepId },
        'pts-global-step'
      );
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializeGroups, { once: true });
    } else {
      initializeGroups();
    }

    document.addEventListener('shopify:section:load', initializeGroups);

    window.PtsLanding = {
      addToCart,
      bindGroup,
      initializeGroups,
      readState,
      setState,
      slugify,
      syncGroupUi,
      subscribe,
    };
  })();
  } catch(e) { console.error(e); }
})();

})();
